import "./index.scss";

import { BellCorpStudioLogoContainer } from "../../common-utilities/Bellcorp-Studio-Logo";
import IntranetHeader from "../../../core/header";
import HomeRedirect from "../../common-utilities/core/home-redirect";
import { tokenMainKeys, appSlugs } from "../../../utils/constants";
import { IconButton } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
const getTitle = () => {
  const section = window?.location?.pathname?.split("/").pop();
  if (["sales"].includes(section)) {
    return "Sales Dashboard";
  }
  return "Profit And Loss Report";
};

const goBack = () => {
  const section = window?.location?.pathname?.split("/").pop();
  if (["sales"].includes(section) || ["summary"].includes(section)) {
    return true;
  }
  return false;
};

const MainContainer = ({
  token = tokenMainKeys.invoiceTracking,
  slug = appSlugs.invoiceTracking,
  children,
}) => {
  const navigate = useNavigate();
  return (
    <>
      <div className="main-container">
        <IntranetHeader />
        <div className="side-nav-header">
          <HomeRedirect localstorageKey={token} />
          {goBack() && (
            <IconButton onClick={() => navigate(-1)}>
              <ArrowBack />
            </IconButton>
          )}
          <h4>{getTitle()}</h4>
        </div>

        <div className="main-right-container">
          <div className="content-div">
            <div>{children}</div>
            <BellCorpStudioLogoContainer />
          </div>
        </div>
      </div>
    </>
  );
};

export default MainContainer;
